import { useTripsContext } from '../GlobalContextProvider';
import { type Filters } from '../../../types';
import { getFilters } from '../utils/context-utils';

export const useTripFilters = (): Filters => {
  const context = useTripsContext();
  return getFilters(context);
};
